//프로젝트 상태
export enum ProjectStatus {
    예정 = "예정",
    진행중 = "진행중",
    완료 = "완료"
}

//프로젝트 가공방식
export enum ProjectType {
    POLYGON = "POLYGON",
    BBOX = "BBOX",
    TAGGING = "TAGGING",
}

//프로젝트 정렬 기준
export enum ProjectSort {
    //회사명
    COMPANY_ASC = "COMPANY_ASC",
    COMPANY_DESC = "COMPANY_DESC",
    //프로젝트명
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
    //생성일자
    CREATE_ASC = "CREATE_ASC",
    CREATE_DESC = "CREATE_DESC",
    //시작일
    START_ASC = "START_ASC",
    START_DESC = "START_DESC",
    //마감일
    END_ASC = "END_ASC",
    END_DESC = "END_DESC",
    //데이터 양
    AMOUNT_ASC = "AMOUNT_ASC",
    AMOUNT_DESC = "AMOUNT_DESC",
}

//프로젝트 추가 요청 정렬 기준
export enum ProjectRequestSort {
    //회사명
    COMPANY_ASC = "COMPANY_ASC",
    COMPANY_DESC = "COMPANY_DESC",
    //프로젝트명
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
    //생성일
    CREATE_ASC = "CREATE_ASC",
    CREATE_DESC = "CREATE_DESC",
    //최근 수정일
    UPDATE_ASC = "UPDATE_ASC",
    UPDATE_DESC = "UPDATE_DESC",
    //어드민 처리일
    CONFIRM_ASC = "CONFIRM_ASC",
    CONFIRM_DESC = "CONFIRM_DESC",
    //데이터양
    AMOUNT_ASC = "AMOUNT_ASC",
    AMOUNT_DESC = "AMOUNT_DESC",
}

//프로젝트 검색 대상
export enum ProjectTarget {
    COMPANY_NAME = 'companyName',
    PROJECT_NAME = 'projectName',
    ALL = 'ALL'
}

